import React from "react";

import GridRow from "../../commons/GridRow";

export default function ThumbnailGrid({ children, ...otherProps }) {
  return <GridRow {...otherProps}>{children}</GridRow>;
}

function Featured({ children, ...otherProps }) {
  return (
    <GridRow.Col>
      <GridRow variant="half">{children}</GridRow>
    </GridRow.Col>
  );
}

function Thumbnails({ children, ...otherProps }) {
  return (
    <GridRow.Col>
      <GridRow variant="threeColumns">{children}</GridRow>
    </GridRow.Col>
  );
}

ThumbnailGrid.Featured = Featured;
ThumbnailGrid.Thumbnails = Thumbnails;
